import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import YouTube from "react-youtube";
import { Rnd } from "react-rnd";
import AgoraRTC from "agora-rtc-sdk-ng";
import {
  doc,
  onSnapshot,
  updateDoc,
  setDoc,
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot as onMessagesSnapshot,
} from "firebase/firestore";
import { auth, db } from "../firebase";

const AGORA_APP_ID = "9e4b1aa26be44917ba88059e009d7b66";
const AGORA_CHANNEL = "room123";
const AGORA_TOKEN =
  "007eJxTYOjukJwm0rumfaFGdqDi1tjvLhvZK0Muzmat7Lq7u/Lt1vcKDJapJkmGiYlGZkmpJiaWhuZJiRYWBqaWqQYGlinmSWZm3oLTMxoCGRlMnWRYGBkgEMRnZyjKz881NDJmYAAAjqMe8A==";
const UID = Math.floor(Math.random() * 1000000);

export default function WatchPage() {
  const { roomCode } = useParams();
  const [roomData, setRoomData] = useState(null);
  const [playerReady, setPlayerReady] = useState(false);
  const [inputUrl, setInputUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState("");
  const [micOn, setMicOn] = useState(false);

  const playerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const rtcClientRef = useRef(null);
  const localMicTrackRef = useRef(null);

  const userId = auth.currentUser?.uid;
  const roomRef = doc(db, "rooms", roomCode);
  const messagesRef = collection(db, "rooms", roomCode, "messages");

  const onReady = (e) => {
    playerRef.current = e.target;
    setPlayerReady(true);
  };

  // دریافت وضعیت اتاق
  useEffect(() => {
    const unsub = onSnapshot(roomRef, (snap) => {
      setRoomData(snap.exists() ? snap.data() : null);
      setLoading(false);
    });
    return () => unsub();
  }, [roomCode]);

  // چت زنده
  useEffect(() => {
    const q = query(messagesRef, orderBy("createdAt", "asc"));
    const unsub = onMessagesSnapshot(q, (snap) => {
      setMessages(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // اتصال به Agora برای صدای میکروفن
  useEffect(() => {
    const joinAgora = async () => {
      const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
      rtcClientRef.current = client;

      client.on("user-published", async (user, type) => {
        await client.subscribe(user, type);
        if (type === "audio") user.audioTrack?.play();
      });

      await client.join(AGORA_APP_ID, AGORA_CHANNEL, AGORA_TOKEN, UID);
    };

    joinAgora();
    return () => rtcClientRef.current?.leave();
  }, []);

  // سینک ویدیو هر ثانیه
  useEffect(() => {
    if (!playerReady || !roomData) return;
    const iv = setInterval(async () => {
      const ct = playerRef.current.getCurrentTime();
      const play = roomData.play;
      const diff = Math.abs(ct - (roomData.currentTime || 0));

      if (play && diff > 5) {
        playerRef.current.seekTo(roomData.currentTime || 0, true);
      }

      const state = playerRef.current.getPlayerState();
      if (play ? state !== 1 : state === 1) {
        play ? playerRef.current.playVideo() : playerRef.current.pauseVideo();
      }

      await updateDoc(roomRef, {
        currentTime: ct,
        play,
        lastUpdate: new Date(),
      });
    }, 1000);
    return () => clearInterval(iv);
  }, [playerReady, roomData]);

  // کنترل پخش/توقف
  const togglePlay = async () => {
    if (!roomData) return;
    const newPlay = !roomData.play;
    const ct = playerRef.current?.getCurrentTime() || 0;
    await updateDoc(roomRef, {
      play: newPlay,
      currentTime: ct,
      lastUpdate: new Date(),
    });
  };

  // کنترل میکروفن
  const toggleMic = async () => {
    try {
      if (!micOn) {
        const mic = await AgoraRTC.createMicrophoneAudioTrack({
          encoderConfig: { sampleRate: 48000, stereo: true, bitrate: 128 },
          AEC: true,
          AGC: true,
          ANS: true,
        });
        localMicTrackRef.current = mic;
        await rtcClientRef.current.publish([mic]);
      } else {
        await rtcClientRef.current.unpublish([
          localMicTrackRef.current,
        ]);
        localMicTrackRef.current.stop();
        localMicTrackRef.current.close();
        localMicTrackRef.current = null;
      }
      setMicOn(!micOn);
    } catch (e) {
      console.error("Mic error:", e);
    }
  };

  // ارسال لینک یوتیوب جدید
  const handleSubmitUrl = async (e) => {
    e.preventDefault();
    const vid = extractVideoId(inputUrl);
    if (!vid) return alert("لینک یوتیوب معتبر نیست!");
    await setDoc(
      roomRef,
      { videoUrl: inputUrl, play: false, currentTime: 0 },
      { merge: true }
    );
    setInputUrl("");
  };

  // ارسال پیام چت
  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!messageText.trim()) return;
    await addDoc(messagesRef, {
      userId,
      text: messageText.trim(),
      createdAt: new Date(),
    });
    setMessageText("");
  };

  if (loading) return <div>در حال بارگذاری...</div>;
  if (!roomData?.videoUrl) {
    return (
      <div style={{ padding: 20 }}>
        <h2>هیچ ویدیویی انتخاب نشده است</h2>
        <form onSubmit={handleSubmitUrl}>
          <input
            value={inputUrl}
            onChange={(e) => setInputUrl(e.target.value)}
            placeholder="لینک یوتیوب"
            style={{ width: 300, padding: 8 }}
          />
          <button type="submit" style={{ marginLeft: 8 }}>
            ارسال
          </button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <div style={{ flex: 1, padding: "1rem", position: "relative" }}>
        <YouTube
          videoId={extractVideoId(roomData.videoUrl)}
          opts={{
            height: "390",
            width: "640",
            playerVars: { autoplay: 0, controls: 1 },
          }}
          onReady={onReady}
        />
        <div
          style={{
            position: "absolute",
            bottom: 20,
            left: 20,
            display: "flex",
            gap: 12,
          }}
        >
          <button onClick={togglePlay} style={btnStyle}>
            {roomData.play ? "توقف" : "شروع"}
          </button>
          <button
            onClick={toggleMic}
            style={{
              ...btnStyle,
              backgroundColor: micOn ? "#f44336" : "#4CAF50",
            }}
          >
            {micOn ? "قطع میکروفن" : "پخش صدا"}
          </button>
        </div>
      </div>

      <Rnd
        default={{
          x: window.innerWidth - 320,
          y: 100,
          width: 300,
          height: 400,
        }}
        bounds="window"
        enableResizing
        minWidth={250}
        minHeight={300}
      >
        <div
          style={{
            background: "#fff",
            border: "1px solid #ccc",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            borderRadius: 8,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: 8,
              backgroundColor: "#f5f5f5",
            }}
          >
            {messages.map((m) => (
              <div
                key={m.id}
                style={{
                  marginBottom: 8,
                  padding: 8,
                  backgroundColor:
                    m.userId === userId ? "#d1ffd6" : "#fff",
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }}
              >
                <div style={{ fontSize: 12, color: "#555" }}>
                  {m.userId.slice(0, 6)}
                </div>
                <div>{m.text}</div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          <form
            onSubmit={handleSendMessage}
            style={{
              display: "flex",
              gap: 8,
              padding: 8,
              borderTop: "1px solid #ccc",
            }}
          >
            <input
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              placeholder="پیام خود را بنویسید..."
              style={{
                flex: 1,
                padding: 8,
                border: "1px solid #ddd",
                borderRadius: 4,
              }}
            />
            <button
              type="submit"
              style={{
                padding: "8px 16px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: 4,
              }}
            >
              ارسال
            </button>
          </form>
        </div>
      </Rnd>
    </div>
  );
}

function extractVideoId(u) {
  const m = u?.match(
    /^.*(?:youtu\.be\/|v\/|embed\/|watch\?v=)([^#&?]*).*/
  );
  return m && m[1]?.length === 11 ? m[1] : null;
}

const btnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2196F3",
  color: "white",
  border: "none",
  borderRadius: 4,
  cursor: "pointer",
};